import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Divider,
} from "@mui/material";
import moment from "moment";

const RowItem = ({
  label,
  value,
  isBold = false,
  isRed = false,
  isGrey = false,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 0.5,
      px: 2,
      borderBottom: "0.5px solid #ccc",
    }}
  >
    <Typography
      variant={isBold ? "subtitle1" : "body1"}
      sx={{
        fontWeight: isBold ? "bold" : "normal",
        color: isRed
          ? "error.main"
          : isGrey
            ? "text.secondary"
            : "text.primary",
        flex: 1,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant={isBold ? "subtitle1" : "body1"}
      sx={{
        fontWeight: isBold ? "bold" : "normal",
        color: isRed
          ? "error.main"
          : isGrey
            ? "text.secondary"
            : "text.primary",
        textAlign: "right",
        flex: 1,
      }}
    >
      {value}
    </Typography>
  </Box>
);

const formatRupiah = (amount) => {
  if (amount === null || amount === undefined) return "Rp 0";
  const isNegative = amount < 0;
  const formatted = Math.abs(amount).toLocaleString("id-ID", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${isNegative ? "(-) " : ""}Rp ${formatted}`;
};

const DetailSetoranHarianModal = ({
  open,
  onClose,
  dataDetail,
  dataPengeluaran,
  onSaveWarkat,
}) => {
  if (!open) return null;
  console.log("Data dataDetail", dataDetail);

  const hasData = !!dataPengeluaran;

  const hitungPecahan = (hasData, total, masuk, keluar, nominal) => {
    const totalVal = (total ?? 0) / nominal;
    const masukVal = (masuk ?? 0) / nominal;
    const keluarVal = (keluar ?? 0) / nominal;
    const hasil = totalVal + masukVal - keluarVal;
    return !hasData
      ? totalVal
      : `${hasil} (${totalVal} + ${masukVal} - ${keluarVal}) = ${formatRupiah(
          hasil * nominal,
        )}`;
  };
  const payloadDataWarkat = {
    nama: "Setoran Tunai Harian Cabang",
    tanggal: moment(dataDetail.tanggal_kas).format(),
    tipe: "pemasukan",
    status: "realisasi",
    catatan: "Setoran dari semua cabang",
    nominal: hasData
      ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Number(dataPengeluaran?.nominal_pendapatan || 0) -
        Number(dataPengeluaran?.nominal_pengeluaran || 0) +
        Number(dataDetail?.total_stl_akumulasi || 0) +
        Number(dataDetail?.total_debit_credit_akumulasi || 0) +
        Number(dataDetail?.total_ewallet_akumulasi || 0) +
        Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
        Number(dataPengeluaran?.transfer_pendapatan || 0)
      : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
        Number(dataDetail?.total_stl_akumulasi || 0) +
        Math.abs(
          Number(dataDetail?.total_selisih_murni_akumulasi_kondisi || 0),
        ) +
        Number(dataDetail?.total_debit_credit_akumulasi || 0) +
        Number(dataDetail?.total_ewallet_akumulasi || 0) +
        Number(dataDetail?.total_pengeluaran_akumulasi || 0),
  };

  const handleSaveWarkat = () => {
    onSaveWarkat(payloadDataWarkat);
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: { width: "95 vw", maxHeight: "95 vh" },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          DETAIL SETORAN GLOBAL
        </Typography>
        <Typography color="text.secondary">
          Prima Centre DC - Sukabumi
        </Typography>
        <Typography color="text.secondary">
          {`Sinkron - ${
            dataDetail?.tanggal_kas
              ? moment(dataDetail.tanggal_kas).format("DD MMMM YYYY")
              : "-"
          } || Setoran - ${
            dataDetail?.tanggal_setoran
              ? moment(dataDetail.tanggal_setoran).format("DD MMMM YYYY")
              : "-"
          }`}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ p: 0, overflowY: "auto", maxHeight: "95 vh" }}>
        {/* BAGIAN KIRI */}
        <Box sx={{ display: "flex", borderBottom: "0.5px solid #ccc" }}>
          <Box sx={{ flex: 1, borderRight: "1px solid #eee", px: 2, py: 1 }}>
            <RowItem
              label="Jumlah Cabang"
              value={dataDetail?.jumlah_cabang?.toString() || "0"}
            />
            <RowItem
              label="Uang Cash"
              value={formatRupiah(
                dataDetail?.total_setoran_cash_akumulasi -
                  dataDetail?.total_transfer,
              )}
              isBold
            />

            {hasData && (
              <>
                <Box
                  sx={{
                    paddingY: 0.5,
                    paddingX: 2,
                    borderBottom: "0.5px solid #ccc",
                    backgroundColor: "#e8f5e9",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "600",
                        color: "success.main",
                      }}
                    >
                      Pendapatan (+)
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "success.main", fontWeight: "500" }}
                    >
                      {formatRupiah(dataPengeluaran?.nominal_pendapatan || 0)}
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    paddingY: 0.5,
                    paddingX: 2,
                    borderBottom: "0.5px solid #ccc",
                    backgroundColor: "#ffebee",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "600",
                        color: "error.main",
                      }}
                    >
                      Pengeluaran (-)
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "error.main", fontWeight: "500" }}
                    >
                      {formatRupiah(dataPengeluaran?.nominal_pengeluaran || 0)}
                    </Typography>
                  </Box>
                </Box>
              </>
            )}

            {!hasData && (
              <RowItem
                label="Selisih Minus"
                value={formatRupiah(
                  dataDetail?.total_selisih_murni_akumulasi_kondisi,
                )}
              />
            )}
            <RowItem
              label="Total Uang Cash"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) -
                      Number(dataDetail?.total_transfer || 0) +
                      Number(dataPengeluaran?.nominal_pendapatan || 0) -
                      Number(dataPengeluaran?.nominal_pengeluaran || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Math.abs(
                        Number(
                          dataDetail?.total_selisih_murni_akumulasi_kondisi ||
                            0,
                        ),
                      ),
              )}
            />
            {hasData && (
              <Box
                sx={{
                  paddingY: 0.5,
                  paddingX: 2,
                  borderBottom: "0.5px solid #ccc",
                  backgroundColor: "#e8f5e9",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "600",
                      color: "success.main",
                    }}
                  >
                    Pendapatan Transfer (+)
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "success.main", fontWeight: "500" }}
                  >
                    {formatRupiah(dataPengeluaran?.transfer_pendapatan || 0)}
                  </Typography>
                </Box>
              </Box>
            )}

            <RowItem
              label="Uang Transfer"
              value={formatRupiah(dataDetail?.total_transfer)}
              isBold
            />
            <RowItem
              label="Total Uang Transfer"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataPengeluaran?.transfer_pendapatan || 0) +
                      Number(dataDetail?.total_transfer || 0)
                  : Number(dataDetail?.total_transfer || 0),
              )}
            />
            <RowItem
              label="Subtotal Omzet"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Number(dataPengeluaran?.nominal_pendapatan || 0) -
                      Number(dataPengeluaran?.nominal_pengeluaran || 0) +
                      Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Math.abs(
                        Number(
                          dataDetail?.total_selisih_murni_akumulasi_kondisi ||
                            0,
                        ),
                      ),
              )}
            />

            <RowItem
              label="STL"
              value={formatRupiah(dataDetail?.total_stl_akumulasi)}
            />
            <RowItem
              label="EDC Machine"
              value={formatRupiah(dataDetail?.total_debit_credit_akumulasi)}
            />
            <RowItem
              label="Qris"
              value={formatRupiah(dataDetail?.total_ewallet_akumulasi)}
            />
            <RowItem
              label="Pengeluaran"
              value={formatRupiah(dataDetail?.total_pengeluaran_akumulasi)}
            />

            <RowItem
              label="Total Omzet"
              isBold
              value={formatRupiah(
                hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Number(dataPengeluaran?.nominal_pendapatan || 0) -
                      Number(dataPengeluaran?.nominal_pengeluaran || 0) +
                      Number(dataDetail?.total_stl_akumulasi || 0) +
                      Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                      Number(dataDetail?.total_ewallet_akumulasi || 0) +
                      Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
                      Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                      Number(dataDetail?.total_stl_akumulasi || 0) +
                      Math.abs(
                        Number(
                          dataDetail?.total_selisih_murni_akumulasi_kondisi ||
                            0,
                        ),
                      ) +
                      Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                      Number(dataDetail?.total_ewallet_akumulasi || 0) +
                      Number(dataDetail?.total_pengeluaran_akumulasi || 0),
              )}
            />

            <RowItem
              label="Total Omzet Data Server"
              isBold
              value={formatRupiah(
                Number(dataDetail?.total_omzet_data_akumulasi || 0),
              )}
            />

            <RowItem
              label="Total Selisih Omzet"
              isBold
              value={formatRupiah(
                (hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataPengeluaran?.nominal_pendapatan || 0) -
                    Number(dataPengeluaran?.nominal_pengeluaran || 0) +
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0) +
                    Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
                    Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Math.abs(
                      Number(
                        dataDetail?.total_selisih_murni_akumulasi_kondisi || 0,
                      ),
                    ) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0) +
                    Number(dataDetail?.total_pengeluaran_akumulasi || 0)) -
                  Number(dataDetail?.total_omzet_data_akumulasi || 0),
              )}
              isRed={
                (hasData
                  ? Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataPengeluaran?.nominal_pendapatan || 0) -
                    Number(dataPengeluaran?.nominal_pengeluaran || 0) +
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0) +
                    Number(dataDetail?.total_pengeluaran_akumulasi || 0) +
                    Number(dataPengeluaran?.transfer_pendapatan || 0)
                  : Number(dataDetail?.total_setoran_cash_akumulasi || 0) +
                    Number(dataDetail?.total_stl_akumulasi || 0) +
                    Math.abs(
                      Number(
                        dataDetail?.total_selisih_murni_akumulasi_kondisi || 0,
                      ),
                    ) +
                    Number(dataDetail?.total_debit_credit_akumulasi || 0) +
                    Number(dataDetail?.total_ewallet_akumulasi || 0) +
                    Number(dataDetail?.total_pengeluaran_akumulasi || 0)) -
                  Number(dataDetail?.total_omzet_data_akumulasi || 0) <
                0
              }
            />

            {dataDetail?.catatan_akumulasi &&
              dataDetail.catatan_akumulasi
                .split(" ; ")
                .filter((item) => item.trim())
                .map((item, i) => (
                  <Typography
                    key={i}
                    variant="body2"
                    sx={{ mt: 1, px: 2, color: "text.secondary" }}
                  >
                    <b>Note {i + 1}:</b> {item.trim()}
                  </Typography>
                ))}
            <Divider />
          </Box>

          {/* BAGIAN KANAN */}
          <Box sx={{ flex: 1, px: 2, py: 1 }}>
            <RowItem label="Rincian" isBold />
            {[
              {
                label: "100rb",
                nominal: 100000,
                total: dataDetail?.total_lembar_seratus,
                masuk: dataPengeluaran?.seratus_pendapatan,
                keluar: dataPengeluaran?.seratus_pengeluaran,
              },
              {
                label: "50rb",
                nominal: 50000,
                total: dataDetail?.total_lembar_limapuluh,
                masuk: dataPengeluaran?.limapuluh_pendapatan,
                keluar: dataPengeluaran?.limapuluh_pengeluaran,
              },
              {
                label: "20rb",
                nominal: 20000,
                total: dataDetail?.total_lembar_duapuluh,
                masuk: dataPengeluaran?.duapuluh_pendapatan,
                keluar: dataPengeluaran?.duapuluh_pengeluaran,
              },
              {
                label: "10rb",
                nominal: 10000,
                total: dataDetail?.total_lembar_sepuluh,
                masuk: dataPengeluaran?.sepuluh_pendapatan,
                keluar: dataPengeluaran?.sepuluh_pengeluaran,
              },
              {
                label: "5rb",
                nominal: 5000,
                total: dataDetail?.total_lembar_limaribu,
                masuk: dataPengeluaran?.limaribu_pendapatan,
                keluar: dataPengeluaran?.limaribu_pengeluaran,
              },
              {
                label: "2rb",
                nominal: 2000,
                total: dataDetail?.total_lembar_duaribu,
                masuk: dataPengeluaran?.duaribu_pendapatan,
                keluar: dataPengeluaran?.duaribu_pengeluaran,
              },
              {
                label: "1rb",
                nominal: 1000,
                total: dataDetail?.total_lembar_seribu,
                masuk: dataPengeluaran?.seribu_pendapatan,
                keluar: dataPengeluaran?.seribu_pengeluaran,
              },
            ].map((p, i) => (
              <RowItem
                key={i}
                label={`Pecahan ${p.label}`}
                value={hitungPecahan(
                  hasData,
                  p.total,
                  p.masuk,
                  p.keluar,
                  p.nominal,
                )}
              />
            ))}

            <RowItem
              label="Pecahan Coin"
              value={
                !hasData
                  ? formatRupiah(dataDetail?.total_coin ?? 0)
                  : `${formatRupiah(
                      (Number(dataDetail?.total_coin) ?? 0) +
                        (Number(dataPengeluaran?.coin_pendapatan) ?? 0) -
                        (Number(dataPengeluaran?.coin_pengeluaran) ?? 0),
                    )} (${formatRupiah(
                      dataDetail?.total_coin ?? 0,
                    )} + ${formatRupiah(
                      dataPengeluaran?.coin_pendapatan ?? 0,
                    )} - ${formatRupiah(
                      dataPengeluaran?.coin_pengeluaran ?? 0,
                    )})`
              }
            />

            {/* <RowItem
              label="Transfer"
              value={formatRupiah(dataDetail?.total_transfer ?? 0)}
            /> */}
          </Box>
        </Box>

        {/* LIST PENDAPATAN & PENGELUARAN */}
        {hasData && (
          <Box sx={{ px: 2, py: 1, mt: 1 }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              textAlign="center"
              mb={2}
            >
              Rincian Pendapatan & Pengeluaran
            </Typography>
            <Box sx={{ display: "flex", gap: 3 }}>
              {/* Pendapatan */}
              <Box
                sx={{
                  flex: 1,
                  border: "1px solid #eee",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  mb={1}
                  color="success.main"
                >
                  PENDAPATAN
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Pendapatan
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="success.main"
                  mb={1}
                >
                  {formatRupiah(dataPengeluaran.nominal_pendapatan)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  List Pendapatan
                </Typography>
                {dataPengeluaran.list_pendapatan ? (
                  dataPengeluaran.list_pendapatan.split(";").map((item, i) => (
                    <Typography key={i} variant="body2">
                      {i + 1}. {item.trim()}
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body2">-</Typography>
                )}
              </Box>

              {/* Pengeluaran */}
              <Box
                sx={{
                  flex: 1,
                  border: "1px solid #eee",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  mb={1}
                  color="error.main"
                >
                  PENGELUARAN
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Pengeluaran
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color="error.main"
                  mb={1}
                >
                  {formatRupiah(dataPengeluaran.nominal_pengeluaran)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  List Pengeluaran
                </Typography>
                {dataPengeluaran.list_pengeluaran ? (
                  dataPengeluaran.list_pengeluaran.split(";").map((item, i) => (
                    <Typography key={i} variant="body2">
                      {i + 1}. {item.trim()}
                    </Typography>
                  ))
                ) : (
                  <Typography variant="body2">-</Typography>
                )}
              </Box>
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          p: 2,
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Button
          onClick={handleSaveWarkat}
          variant="contained"
          sx={{
            fontWeight: "bold",
            flexGrow: 1,
            backgroundColor: (t) => t.palette.secondary[300],
            color: "white",
          }}
        >
          {dataDetail.has_save_warkat
            ? "PERBAHARUI KE DATA WARKAT"
            : "SIMPAN KE DATA WARKAT"}
        </Button>

        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            fontWeight: "bold",
            flexGrow: 1,
            backgroundColor: (t) => t.palette.grey[300],
            color: (t) => t.palette.text.primary,
            "&:hover": { backgroundColor: (t) => t.palette.grey[400] },
          }}
        >
          TUTUP
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetailSetoranHarianModal;
